import React from 'react';
import { motion } from 'framer-motion';
import { ProjectCategory } from '../types';
import { cn } from '../../../utils/cn';

interface PortfolioFilterProps {
  activeFilter: ProjectCategory;
  onFilterChange: (filter: ProjectCategory) => void;
}

const PortfolioFilter: React.FC<PortfolioFilterProps> = ({ 
  activeFilter, 
  onFilterChange 
}) => {
  const filters: ProjectCategory[] = ['All', 'Website', 'Mobile App'];

  return (
    <div className="flex flex-wrap justify-center gap-4 mb-12">
      {filters.map((filter) => (
        <motion.button
          key={filter}
          onClick={() => onFilterChange(filter)}
          className={cn(
            "px-8 py-3 rounded-full text-sm font-medium border-2",
            "transition-all duration-300 transform",
            "hover:scale-105 active:scale-95",
            activeFilter === filter
              ? "bg-primary-500 text-white border-primary-500"
              : "bg-transparent text-gray-600 border-gray-300"
          )}
          whileHover={{ y: -2 }}
          whileTap={{ y: 0 }}
        >
          {filter}
        </motion.button>
      ))}
    </div>
  );
};

export default PortfolioFilter;